module.exports = __webpack_public_path__ + "assets/img/10.4ed5dcbd.png";